import { defineWidgetSettings } from "@nexus/widget-sdk";
import { ANIMATE_CHART_CONFIG, MISSING_DATA_CONFIG } from "@nexus/widget-kit";
import { DEFAULT_LOW_SAMPLE_THRESHOLD } from "./model";

/** What an author sets on the weekly Network ID chart. */
export const settings = defineWidgetSettings({
  id: "network-id-weekly",
  extends: [MISSING_DATA_CONFIG, ANIMATE_CHART_CONFIG],
  properties: {
    lowSampleThreshold: {
      type: "integer",
      title: "Low sample below",
      default: DEFAULT_LOW_SAMPLE_THRESHOLD,
      oneOf: [10, 20, 30, 50, 100].map((value) => ({ const: value, title: `${value} detections` })),
      "x-ui": { category: "display", order: 10, keepDefault: true },
    },
    weekLabels: {
      type: "string",
      title: "Week labels",
      default: "all",
      oneOf: [
        { const: "all", title: "Always show every week" },
        { const: "auto", title: "Skip when crowded" },
      ],
      "x-ui": { category: "display", order: 20, keepDefault: true },
    },
  },
});
